const mapLocationSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="484.01px" height="484.01px" viewBox="0 0 484.01 484.01" enable-background="new 0 0 484.01 484.01" xml:space="preserve">
<g>
	<path fill="#FFFFFF" d="M457.021,309.3l20.238-159.582L332.072,94.625l-45.974,21.953c-1.419,7.021-3.57,13.854-6.385,20.428
		l34.804-16.617l-14.369,154.664l0.804,8.285L194.91,299.334l-8.703,17.164l116.276-17.53l13.405,137.177l15.604-1.537
		l-13.488-137.969l1.359-0.214l121.573,15.403l0.295-2.376l18.371,154.282l-126.609-29.223L168.24,465.898l-1.372-0.26
		l14.811-140.726l-0.099-0.855l-0.605-5.272l-20.301-40.075l2.864,25.353l-3.621,0.544L42.475,286.412l0.696-5.781L25.177,138.755
		l82.171,34.693l-6.859-13.521c-2.219-2.876-4.229-5.892-6.135-8.958L6.188,113.735L27.373,280.69l-0.398,3.321l-0.295-0.048
		L24.27,299.45l0.866,0.118l-18.1,152.037l161.226,30.229L332.7,450.519l145.121,33.49L457.021,309.3z M319.188,280.596
		l-2.707,0.396l-0.592-5.894l15.107-162.587l1.785-0.854l127.365,48.326l-17.295,136.264L319.188,280.596z M151.41,462.742
		L24.329,438.91l16.314-136.918l119.252,18.479l5.417-0.815l0.605,5.319L151.41,462.742z M183.018,322.8l-2.033-4.009l-0.165-1.478
		l5.394-0.815L183.018,322.8z M112.68,146.528l69.248,136.657l68.493-135.194c13.453-15.687,21.635-36.017,21.635-58.268
		C272.055,40.249,231.802,0,182.326,0c-49.473,0-89.71,40.249-89.71,89.724c0,21.542,7.637,41.315,20.33,56.805H112.68z
		 M182.332,34.578c30.402,0,55.147,24.742,55.147,55.146c0,30.4-24.745,55.146-55.147,55.146c-30.401,0-55.145-24.746-55.145-55.146
		C127.188,59.32,151.924,34.578,182.332,34.578z"/>
</g>
</svg>
`;

export default mapLocationSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/mapLocationSVG.js